import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.service';
import { NotificationService } from '../common/component/notification/notification.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls:['unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  homePageData: any;
  constructor(private homeService: HomeService, private notificationService: NotificationService) {
    this.homeService.get().subscribe({
      next: homePageData => {
        this.homePageData = homePageData[0];
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Home Page data", error);
      }
    });
  }

  ngOnInit(): void {
  }

}

